var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-container"},[_c('div',{staticClass:"no-data-content w-full sm:w-2/3 lg:w-1/2"},[_c('div',{},[_c('img',{attrs:{"src":"/img/noData.png","alt":""}})]),_c('p',{staticClass:"message"},[_vm._v("The link you followed has exprired")])])])
}]

export { render, staticRenderFns }